<template>
  <div class="custom-widget-editor">
    <position-editor :values="values" @update-model="updateModel" />
    <div class="control-row text-row">
      <b-input-group class="control" size="sm" prepend="widgetName">
        <b-form-select :value="values.widgetName" @input="updateModel('widgetName', $event)" :options="availableCustomWidgets"/>
      </b-input-group>
    </div>
  </div>
</template>
<script>
import PositionEditor from '../PositionEditor.vue';

export default {
  name: 'TextWidgetEditor',
  components: {
    PositionEditor,
  },
  props: {
    values: {},
  },
  computed: {
    availableCustomWidgets() {
      return [
        'SignupOrRedirect',
        'ShareEoy',
        'ShareEoc',
      ];
    },
  },
  methods: {
    updateModel(field, value) {
      this.$emit('update', field, value);
    },
  },
};

</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

$button_radius: 4px;

.custom-widget-editor {
  .control-row {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    &:first-of-type {
      margin-top: 0px;
    }
    align-items: center;
    &.text-row {
      margin-bottom: 15px;
      &::v-deep .control input {
        text-align: right;
        direction: rtl;
      }
    }
    div {
      &:not(:last-of-type) {
        margin-right: 10px;
      }
    }
  }
}
</style>
